'use strict';

// ----------------------------------------
// Imports
// ----------------------------------------

import 'jquery-ui-slider/jquery-ui';
import '../_vendors/jquery-ui-touch';
// ----------------------------------------
// Private
// ----------------------------------------

let $rangeSlider = $('.price-slider');
let $minCost = $('.min-cost');
let $maxCost = $('.max-cost');
let min = $rangeSlider.data('min');
let max = $rangeSlider.data('max');

// ----------------------------------------
// Public
// ----------------------------------------

function initRangeSlider () {
	if (!$rangeSlider.length) {
		return false;
	}

	$rangeSlider.each(function(i,el){
		let $el = $(el),
			$wrap = $el.closest('.for-filter-js'),
		    $minCost = $wrap.find('.min-cost'),
			$maxCost = $wrap.find('.max-cost');
		let min = $el.data('min'),
			max = $el.data('max');


		$el.slider({
			min: min,
			max: max,
			range: true,
			values: [min, max],

			stop: function (event, ui) {
				$minCost.val($el.slider('values', 0));
				$maxCost.val($el.slider('values', 1));
			},

			slide: function (event, ui) {
				$minCost.val($el.slider('values', 0));
				$maxCost.val($el.slider('values', 1));
			}
		});

		$minCost.change(function () {
			let minValue = $minCost.val();
			let maxValue = $maxCost.val();

			if (parseInt(minValue) > parseInt(maxValue)) {
				minValue = maxValue;
				$minCost.val(minValue);
			}

			$rangeSlider.slider('values', 0, minValue);
		});

		$maxCost.change(function () {
			let minValue = $minCost.val();
			let maxValue = $maxCost.val();

			if (maxValue > max) {
				maxValue = max;
				$maxCost.val(max);
			}

			if (parseInt(minValue) > parseInt(maxValue)) {
				maxValue = minValue;
				$maxCost.val(maxValue);
			}

			$el.slider('values', 1, maxValue);
		});

		$minCost.keypress(function (event) {
			let key;
			let keyChar;

			if (event.keyCode) key = event.keyCode;
			else if (event.which) key = event.which;

			if (key === null || key === 0 || key === 8 || key === 13 || key === 9 || key === 46 || key === 37 || key === 39) return true;
			keyChar = String.fromCharCode(key);

			if (!/^[0-9]+$/.test(keyChar))	return false;
		});

		$maxCost.keypress(function (event) {
			let key;
			let keyChar;

			if (event.keyCode) key = event.keyCode;
			else if (event.which) key = event.which;

			if (key === null || key === 0 || key === 8 || key === 13 || key === 9 || key === 46 || key === 37 || key === 39) return true;
			keyChar = String.fromCharCode(key);

			if (!/^[0-9]+$/.test(keyChar))	return false;
		});


	});


}

// ----------------------------------------
// Exports
// ----------------------------------------

export {initRangeSlider};



// WEBPACK FOOTER //
// ./_HTML/src/js/_modules/range-slider.js